import React from 'react';

export default class Eyes extends React.Component {
	componentDidMount() {
		this.props.getGlassesTargetCoords(this.refs.glassesTarget);
	}
	render() {
		return (
			<g className="fill--face">
				<circle ref="glassesTarget" cx="199.3255768" cy="159.5086517" r="0"/>
				<g className="fill--eyes eyes">
					<ellipse cx="229.3255768" cy="159.5086517" rx="7.6592607" ry="8.5102901"/>
					<ellipse cx="169.3255768" cy="159.5086517" rx="7.6592607" ry="8.5102901"/>
				</g>
				<g className="fill--face eyes--blink">
					<path d="M176.1699219,168.2983398c-0.1542969,0-0.3105469-0.0141602-0.4677734-0.0439453l-15.265625-2.8896484
						c-1.3564453-0.2568359-2.2480469-1.5649414-1.9912109-2.9213867c0.2568359-1.3569336,1.5634766-2.2470703,2.9208984-1.9916992
						l15.265625,2.8896484c1.3564453,0.2568359,2.2480469,1.5649414,1.9912109,2.9213867
						C178.3964844,167.4624023,177.3476562,168.2983398,176.1699219,168.2983398z"/>
					<path d="M221.8984375,168.2983398c-1.1777344,0-2.2265625-0.8359375-2.453125-2.0356445
						c-0.2568359-1.3564453,0.6347656-2.6645508,1.9912109-2.9213867l15.265625-2.8896484
						c1.3564453-0.2558594,2.6650391,0.6347656,2.9208984,1.9916992c0.2568359,1.3564453-0.6347656,2.6645508-1.9912109,2.9213867
						l-15.265625,2.8896484C222.2089844,168.2841797,222.0527344,168.2983398,221.8984375,168.2983398z"/>
				</g>
				<g className="fill--face eyes--is-being-pet--likes">
					<path d="M176.4052734,168.6992188c-0.6044922,0-1.2099609-0.2177734-1.6904297-0.6591797
						c-0.9189453-0.84375-2.9033203-1.7983398-5.7177734-1.9462891c-2.8125-0.1425781-4.8876953,0.5942383-5.8896484,1.3378906
						c-1.1103516,0.8237305-2.6748047,0.5908203-3.4970703-0.5170898c-0.8232422-1.1083984-0.5917969-2.6743164,0.5166016-3.4975586
						c2.234375-1.6591797,5.5507812-2.5053711,9.1318359-2.3164062c3.5683594,0.1875,6.7900391,1.375,8.8388672,3.2578125
						c1.0166016,0.934082,1.0839844,2.515625,0.1494141,3.5322266
						C177.7539062,168.4272461,177.0810547,168.6992188,176.4052734,168.6992188z"/>
					<path d="M222.5205078,168.6992188c-0.6757812,0-1.3486328-0.2719727-1.8417969-0.8085938
						c-0.9345703-1.0166016-0.8671875-2.5981445,0.1494141-3.5322266c2.0488281-1.8828125,5.2705078-3.0703125,8.8388672-3.2578125
						c3.5712891-0.1894531,6.8974609,0.6572266,9.1318359,2.3164062c1.1083984,0.8232422,1.3398438,2.3891602,0.5166016,3.4975586
						c-0.8242188,1.1088867-2.3896484,1.3383789-3.4970703,0.5170898c-1.0009766-0.7436523-3.0634766-1.480957-5.8896484-1.3378906
						c-2.8144531,0.1479492-4.7988281,1.1025391-5.7177734,1.9462891
						C223.7304688,168.4814453,223.125,168.6992188,222.5205078,168.6992188z"/>
				</g>
				<g className="fill--eyes eyes--is-being-pet--hates">
					<path d="M164.0014191,156.512207c-1.1442413-0.0243225-2.146286,0.8135376-2.2757721,1.9506989
						c-0.0390015,0.342453-0.0593262,0.6913605-0.0593262,1.0457916c0,4.7000732,3.4291382,8.5102539,7.6592407,8.5102539
						s7.6593018-3.8101807,7.6593018-8.5102539c0-0.2648621-0.0113831-0.5266418-0.0334015-0.7849426
						c-0.0950928-1.115799-1.0602112-1.958786-2.1797943-1.9825897L164.0014191,156.512207z"/>
					<path d="M223.8821106,156.7286377c-1.1194611,0.0231934-2.0842438,0.8654327-2.1811371,1.9809265
						c-0.0228424,0.2629089-0.0346527,0.5294189-0.0346527,0.7991333c0,4.7000732,3.4291382,8.5102539,7.6592407,8.5102539
						s7.6593018-3.8101807,7.6593018-8.5102539c0-0.3568726-0.0206146-0.7081451-0.0601196-1.052887
						c-0.1302338-1.1364288-1.1309662-1.9739532-2.2746124-1.9502563L223.8821106,156.7286377z"/>
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Cat/Eyes.js